import { toRefs as g, provide as _, resolveComponent as s, openBlock as d, createBlock as k, withCtx as m, renderSlot as C, createElementBlock as f, Fragment as h, renderList as b, createTextVNode as y, toDisplayString as p, createCommentVNode as x } from "vue";
import B from "./design-system.es62.js";
import T from "./design-system.es111.js";
import v from "./design-system.es128.js";
const S = {
  name: "DsToggle",
  components: {
    Inline: B,
    ToggleButton: T
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      default: "radio",
      options: ["radio", "checkbox"]
    },
    checked: {
      type: [String, Number, Array],
      default: null
    },
    dense: Boolean
  },
  emits: ["update:checked"],
  setup(c, { emit: a }) {
    const { dense: o, mode: l } = g(c);
    function r(n) {
      var t;
      return c.mode === "checkbox" ? (t = c.checked) == null ? void 0 : t.includes(n) : c.checked === n;
    }
    function i(n) {
      var t;
      if (c.mode === "checkbox") {
        const e = (t = c.checked) != null && t.includes(n) ? c.checked.filter((u) => u !== n) : [...c.checked, n];
        a("update:checked", e);
      } else
        a("update:checked", n);
    }
    return _("dsToggle", {
      dense: o,
      mode: l
    }), {
      isChecked: r,
      handleOptionClick: i
    };
  }
};
function I(c, a, o, l, r, i) {
  const n = s("ToggleButton"), t = s("Inline");
  return d(), k(t, {
    space: o.dense ? "spacing-100" : "spacing-150"
  }, {
    default: m(() => [
      C(c.$slots, "default", {}, () => [
        (d(!0), f(h, null, b(o.options, (e) => (d(), k(n, {
          key: e.value,
          icon: e.icon,
          "aria-label": e.icon ? e.label : null,
          value: e.value,
          checked: l.isChecked(e.value),
          onClick: (u) => l.handleOptionClick(e.value)
        }, {
          default: m(() => [
            e.icon ? x("", !0) : (d(), f(h, { key: 0 }, [
              y(p(e.label), 1)
            ], 64))
          ]),
          _: 2
        }, 1032, ["icon", "aria-label", "value", "checked", "onClick"]))), 128))
      ])
    ]),
    _: 3
  }, 8, ["space"]);
}
const D = /* @__PURE__ */ v(S, [["render", I]]);
export {
  D as default
};
//# sourceMappingURL=design-system.es110.js.map
